import React from 'react';
import usePlansData from '../../hooks/usePlansData';
import { useGlobalContext } from '../../stores/global';
import Modal from './Modal';

export interface Props {
  onClose: () => void;
  open: boolean;
}

export default function MyPlansModal({ onClose, open }: Props) {
  if (!open) return null;

  const { user } = useGlobalContext();
  const { data } = usePlansData();

  const userPlanReference = user?.plan?.reference;

  const getUserPlan = (planId: string) => {
    return data?.find((el: any) => el.id === planId);
  };

  return (
    <Modal
      open={open}
      title="Mis planes"
      onClose={onClose}
      closeBtn
      containerProps={{ style: { maxWidth: 600 } }}
    >
      <div>
        <p>Mis planes:</p>
        <ul style={{ listStylePosition: 'inside' }}>
          {!data && <li>...</li>}
          {data && !userPlanReference && <li>No tienes ningún plan</li>}
          {data && userPlanReference && (
            <li>
              <b>{getUserPlan(userPlanReference)?.name}</b>
            </li>
          )}
        </ul>
      </div>
    </Modal>
  );
}
